/* ================================================================
   Hope Estate — Silver Member Pricing Popup

   Fires when a visitor clicks a "Shop" entry point (main nav Shop,
   the /collections landing link, or a "Shop Now" style tile).

   - Intercepts the click, shows the popup, remembers where they
     were heading
   - "Sign Up for Silver" sends them to the club form with the
     Silver tier preselected
   - "Continue to Shop" (and the close button / Esc / overlay click)
     sends them on to their original destination
   - Sets a cookie so it only shows once per COOKIE_DAYS

   Sits BELOW the 18+ age gate in z-index (see hope-custom.css) so the
   legal gate always wins if both are ever on screen at once.
   ================================================================ */
(function () {
  'use strict';

  var COOKIE_NAME = 'he_silver_seen';
  var COOKIE_DAYS = 30;
  var CLUB_URL    = '/pages/club-1?tier=silver#club-form';

  /* Link text that counts as a "Shop" entry point. Compared lowercase
     and trimmed, so add new wording here rather than in the logic. */
  var SHOP_LABELS = ['shop', 'shop all', 'shop now', 'shop online', 'shop the range'];

  /* Pathnames that count as the shop landing page. */
  var SHOP_PATHS = ['/collections'];

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }
  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) +
      '; expires=' + expires + '; path=/; SameSite=Lax; Secure';
  }

  /* Already seen it, or already a logged-in member, so don't nag. */
  if (getCookie(COOKIE_NAME) === 'yes') return;
  if (window.heIsMember === true) return;

  var overlay = null;
  var destination = '/collections';

  function isShopLink(a) {
    if (!a || !a.getAttribute('href')) return false;
    if (a.target && a.target !== '_self') return false;

    var href = a.getAttribute('href');
    if (href.charAt(0) === '#' || /^(mailto:|tel:)/i.test(href)) return false;

    /* Only same-origin links. Anything pointing at the brewery or another
       site is left alone. */
    var url;
    try { url = new URL(a.href, window.location.origin); } catch (e) { return false; }
    if (url.origin !== window.location.origin) return false;

    var path = url.pathname.replace(/\/$/, '');
    if (SHOP_PATHS.indexOf(path) !== -1) return true;

    var label = (a.textContent || '').trim().toLowerCase().replace(/\s+/g, ' ');
    return SHOP_LABELS.indexOf(label) !== -1;
  }

  function close(goToDestination) {
    setCookie(COOKIE_NAME, 'yes', COOKIE_DAYS);
    if (!overlay) return;
    overlay.classList.add('he-silver--closing');
    var target = goToDestination ? destination : null;
    setTimeout(function () {
      if (overlay) { overlay.remove(); overlay = null; }
      document.body.style.overflow = '';
      if (target) window.location.href = target;
    }, 300);
  }

  function build() {
    overlay = document.createElement('div');
    overlay.id = 'he-silver-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'he-silver-title');

    overlay.innerHTML =
      '<div class="he-silver__box">' +
        '<button class="he-silver__close" aria-label="Close">&times;</button>' +
        '<p class="he-silver__eyebrow">Hope Estate Club</p>' +
        '<h2 class="he-silver__title" id="he-silver-title">You\'re Already Seeing Silver Pricing</h2>' +
        '<p class="he-silver__sub">' +
          'Every price on this site is our Silver member price. Join the Club at Silver ' +
          'and keep member pricing on every order you place with us.' +
        '</p>' +
        '<ul class="he-silver__benefits">' +
          '<li>Member pricing on wine, beer and spirits</li>' +
          '<li>Priority access to new releases</li>' +
          '<li>Invitations to member-only events</li>' +
          '<li>Early cellar door bookings</li>' +
        '</ul>' +
        '<div class="he-silver__btns">' +
          '<a href="' + CLUB_URL + '" class="he-silver__btn he-silver__btn--gold" id="he-silver-join">Sign Up for Silver</a>' +
          '<button class="he-silver__btn he-silver__btn--plain" id="he-silver-continue">Continue to Shop</button>' +
        '</div>' +
        '<p class="he-silver__note">' +
          'Silver is achieved with a qualifying purchase and continues while you stay ' +
          'subscribed to our mailing list. Prices are subject to change.' +
        '</p>' +
      '</div>';

    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    overlay.querySelector('#he-silver-continue').addEventListener('click', function () {
      close(true);
    });
    overlay.querySelector('.he-silver__close').addEventListener('click', function () {
      close(true);
    });
    overlay.querySelector('#he-silver-join').addEventListener('click', function () {
      setCookie(COOKIE_NAME, 'yes', COOKIE_DAYS);
    });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close(true);
    });
    document.addEventListener('keydown', function onKey(e) {
      if (e.key === 'Escape' && overlay) {
        document.removeEventListener('keydown', onKey);
        close(true);
      }
    });

    /* Keep tabbing inside the dialog */
    var focusable = overlay.querySelectorAll('a, button');
    overlay.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    overlay.querySelector('#he-silver-join').focus();
  }

  document.addEventListener('click', function (e) {
    /* Let modified clicks (new tab, middle click, download) behave normally */
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    if (getCookie(COOKIE_NAME) === 'yes' || overlay) return;

    var a = e.target.closest('a');
    if (!isShopLink(a)) return;

    /* If the age gate is on screen, leave the legal gate alone. */
    if (document.getElementById('he-age-overlay')) return;

    destination = a.href;
    e.preventDefault();
    build();
  }, true);
})();
